import * as Yup from "yup";

export const createTeamSchema = Yup.object().shape({
  team_name: Yup.string().required("Team name is required"),
});

export const editTeamSchema = Yup.object().shape({
  team_name: Yup.string().required("Team name is required"),
});

export const addTeamMemberSchema = Yup.object().shape({
  team_id: Yup.string()
    .max(99, "Team ID cannot exceed 99 characters")
    .required("Team name is required"),
  role_id: Yup.string()
    .max(99, "Role ID cannot exceed 99 characters")
    .required("Role name is required"),
  user_id: Yup.string()
    .max(99, "User ID cannot exceed 99 characters")
    .required("User name is required"),
  // country_id: Yup.string()
  //     .max(99, "country cannot exceed 99 characters")
  //     .required("Country is required"),
});
